<div class="p-20 fx-row fx-wrap align-items-start justify-content-start text-center">
    <span class="title fx-flex-100 mb-5 text-center">{{'SYNC.ERRORS' | translate}}</span>
    <span class="text light fx-flex-100 mb-10 text-center">{{'SYNC.ERRORS_COUNT' | translate:{ count: total } }}</span>
    <table mat-table [dataSource]="errors" style="z-index: 0;">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                    {{'TRADEMARK.NAME' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let error">
                <span class="text bold" *ngIf="error.trademark.name">{{error.trademark.name}}</span>
                <span class="text light" *ngIf="!error.trademark.name">-</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="countryOfDesignation">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                    {{'TRADEMARK.DESIGNATION_COUNTRY_SHORT' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let error">
                <app-document-countries [territories]="[error.trademark.countryOfDesignation]"></app-document-countries>
            </td>
        </ng-container>
        <ng-container matColumnDef="identifierNumber">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                    {{'TRADEMARK.IDENTIFIER_NUMBER' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let error">
                <span class="text">{{error.trademark.identifierNumber}}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="error">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                </span>
            </th>
            <td mat-cell *matCellDef="let error">
                <div class="fx-column align-items-start">
                    <span class="text red">{{failureKey(error) | translate}}</span>
                    @if (hasDetail(error)) {
                        <span class="small light">{{'SYNC.DETAIL_OURS' | translate:{ value: error.detail.ours || '-' } }}</span>
                        <span class="small light">{{'SYNC.DETAIL_OFFICE' | translate:{ value: error.detail.office || '-' } }}</span>
                    }
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                </span>
            </th>
            <td mat-cell *matCellDef="let error">
                @if (error.trademark?._id) {
                    <span [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="(data.enterBlockedReason ?? '') | translate"
                        [matTooltipDisabled]="canOpen() || !data.enterBlockedReason">
                        <span class="text bold" [class.main]="canOpen()" [class.clickable]="canOpen()"
                            [class.light]="!canOpen()" (click)="openTrademark(error)">{{'SYNC.OPEN_TRADEMARK' | translate}}</span>
                    </span>
                }
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>
    <mat-divider class="fx-flex-100 mv-20"></mat-divider>
    <div class="fx-row align-items-center justify-content-center fx-flex-100">
        <button class="button fx-flex mr-10" (click)="onCancel()">{{'ACTIONS.CANCEL' | translate}}</button>
    </div>
</div>